import { useEffect } from "react";

export default function ProjectModal({ project, onClose }) {

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [onClose]);

  useEffect(() => {
    if (!project) return;

    const preventDefault = (e) => e.preventDefault();

    document.addEventListener("touchmove", preventDefault, { passive: false });
    document.addEventListener("wheel", preventDefault, { passive: false });

    return () => {
      document.removeEventListener("touchmove", preventDefault);
      document.removeEventListener("wheel", preventDefault);
    };
  }, [project]);

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="project-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-image-wrapper">
          <img src={project.image} alt={project.title} />
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <h2>{project.title}</h2>

        <div className="stack">
          {project.stack.map((s, i) => (
            <span key={i}>{s}</span>
          ))}
        </div>

        <p className="long-desc">{project.long}</p>

        <div className="modal-actions">
            {project.live && (
                <a
                href={project.live}
                target="_blank"
                rel="noreferrer"
                className="live-btn"
                >
                Check it out!
                </a>
            )}

            {project.github && (
            <a
                href={project.github}
                target="_blank"
                rel="noreferrer"
                className="github-btn"
                aria-label="GitHub Repository"
            >
                <img src="/logos/github.svg" alt="GitHub" />
            </a>
            )}
        </div>
      </div>
    </div>
  );
}

